import React, { useEffect, useState } from 'react';
import { useLazyQuery, useMutation } from '@apollo/client';
import { Form, Card, Row, Col, Button, Accordion } from 'react-bootstrap';
import { UPDATE_SHOP } from '../../../apollo/shop/mutation';
import { GET_SHOP } from '../../../apollo/shop/Query';
import { APP_COLOR, USER_KEY } from '../../../const';
import AnimationLoading from '../../../components/Animationloading';
import { images } from '../../../images/index';
import Switch from "react-switch";
import { FaCheckCircle } from 'react-icons/fa';
import LoadingUpdates from '../../../components/LoadingUpdate';
import _ from 'lodash';

const SetProduct = () => {
  // state
  const [isLastStock, setIsLastStock] = useState(false);
  const [loadingEdit, setLoadingEdit] = useState(false);
  const [isBillNumber, setIsBillNumber] = useState("bill_1");
  const [isBillOfferPrice, setIsBillOfferPrice] = useState(false);
  const [descriptionBill, setDescriptionBill] = useState('ຂອບໃຈລູກຄ້າທີ່ມາອຸດໜຸດ');
  // apollo client hooks
  const [updateShop, { loading: loadingUpdate }] = useMutation(UPDATE_SHOP);
  const [loadShop, { data: shopData, loading: loadingShop }] = useLazyQuery(GET_SHOP, { fetchPolicy: "network-only" });

  // useEffect hooks
  useEffect(() => {
    const userData = localStorage.getItem(USER_KEY);
    if (userData) {
      const shopId = JSON.parse(userData)?.data?.shop?.id;
      if (shopId) {
        handleFecthShopData(shopId)
      }
    }
  }, []);

  useEffect(() => {
    if (shopData) {
      // set data to localStorage
      localStorage.setItem("SHOP_SETTING_DATA", JSON.stringify(shopData?.shop));

      //get shop data from query
      setIsLastStock(shopData?.shop?.isLessStocks || false);
      setIsBillNumber(shopData?.shop?.isBillNumber || "bill_1");
      
      setIsBillOfferPrice(shopData?.shop?.isBillOfferPrice);
      setDescriptionBill(shopData?.shop?.descriptionPOSBill);
    }
  }, [shopData]);
  

  // get shop data
  const handleFecthShopData = async (shopId) => {
    try {
      await loadShop({
        variables: {
          where: {
            id: shopId,
          },
        },
      });

    } catch (error) {
      console.log(error)
    }
  }

  // function to update the shop and refresh local state
  const _updateShop = async (shopId, updatedData) => {
    try {
      if (loadingUpdate) return;
      setLoadingEdit(true);
      const res = await updateShop({
        variables: {
          where: { id: shopId },
          data: updatedData,
        }
      });

      if (res) {
        setLoadingEdit(false);
        handleFecthShopData(shopId)
      }

    } catch (err) {
      console.error('Error updating shop:', err);
      setLoadingEdit(false);
      throw new Error(err);
    }
  };

  // Function to handle switch change for isLastStock
  const handleLastStockSwitchChange = async () => {
    const userData = localStorage.getItem(USER_KEY);
    if (userData) {
      const shopId = JSON.parse(userData)?.data?.shop?.id;
      const newIsLastStock = !isLastStock;

      if (shopId) {
        setIsLastStock(newIsLastStock);
        await _updateShop(shopId, { isLessStocks: newIsLastStock });
      }
    }
  };

  // New: handle select bill template (bill_1, bill_2, bill_3)
  const handleBillExampleClick = async (billType) => {
    const userData = localStorage.getItem(USER_KEY);
    if (userData) {
      const shopId = JSON.parse(userData)?.data?.shop?.id;
      if (shopId) {
        await _updateShop(shopId, { isBillNumber: billType });
        setIsBillNumber(billType);
      }
    }
  };

  // function select offer price bill to update shop where isBillOfferPrice using switch
  const handleSelectOfferPriceBill = async (event) => {
    setIsBillOfferPrice(event.target.checked);
    const userData = localStorage.getItem(USER_KEY);
    if (userData) {
      const shopId = JSON.parse(userData)?.data?.shop?.id;
      const newIsBillOfferPrice = !shopData?.shop?.isBillOfferPrice;

      if (shopId) {
        await _updateShop(shopId, { isBillOfferPrice: newIsBillOfferPrice });
      }
    }
  }

  // handle select bill offer price active
  const handleBillOfferPriceExampleClick = async (item) => {
    const userData = localStorage.getItem(USER_KEY);
    if (userData) {
      const shopId = JSON.parse(userData)?.data?.shop?.id;
      if (shopId) {
        // set data to localStorage
        await _updateShop(shopId, { isBillOfferPrice: item?.type });
        setIsBillOfferPrice(item?.type);
      }
    }
  }

  // handle update description bill to function _updateShop
  const handleUpdateDescriptionBill = async () => {
    const userData = localStorage.getItem(USER_KEY);
    if (userData) {
      const shopId = JSON.parse(userData)?.data?.shop?.id;
      if (shopId) {
        await _updateShop(shopId, { descriptionPOSBill: descriptionBill });
      }
    }
  };

  return (
    <>

      <Card className="p-4 m-2">
        <Card.Header>
          <Card.Title>ຕັ້ງຄ່າການຂາຍ ແລະ ບິນຮັບເງິນ</Card.Title>
        </Card.Header>
        <Card.Body>
          <div className='d-flex gap-2 justify-content-center align-items-center w-100'>
            <Form.Group className="mb-3 w-100" controlId="exampleForm.ControlInput1">
              <Form.Label>ຄຳເວົ້າສ່ວນທ້າຍບິນ</Form.Label>
              <Form.Control type="text" onChange={(e) => setDescriptionBill(e?.target?.value)} value={descriptionBill} />
            </Form.Group>
            <Button type='button' variant='success' onClick={handleUpdateDescriptionBill} className="mt-3">ບັນທຶກ</Button>
          </div>
          <Accordion defaultActiveKey="0">
            <Accordion.Item eventKey="0">
              <Accordion.Header>ການຂາຍເວລາສະຕ໋ອກໝົດ</Accordion.Header>
              <Accordion.Body>
                <ul>
                  <li>ເປີດ ໝາຍເຖິງ ສາມາດຂາຍສິນຄ້າທີ່ໝົດສະຕ໋ອກໄດ້</li>
                  <li>ປິດ ໝາຍເຖິງ ສິນຄ້າທີ່ໝົດສະຕ໋ອກບໍ່ສາມາດມາຂາຍໄດ້</li>
                </ul>
                <div className='d-flex gap-4 pl-4'>
                  <Switch
                    checked={isLastStock}
                    onChange={handleLastStockSwitchChange}
                    onColor="#bfbdc7"
                    onHandleColor={APP_COLOR}
                    handleDiameter={20}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                    activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                    height={20}
                    width={38}
                    className="react-switch"
                    id="material-switch"
                  />
                  <p>{isLastStock ? "ເປີດ" : "ປີດ"}</p>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>ບິນຂາຍຂະໜາດ 80 mm</Accordion.Header>
              <Accordion.Body>
                <div style={{ paddingLeft: 5 }}>
                  <p>ເລືອກແບບຟອມບິນ 80mm ທີ່ຕ້ອງການ</p>
                </div>
                <h5>ຕົວຢ່າງບິນ:</h5>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'start', alignItems: 'center', gap: 15, padding: "10px 0" }}>
                  <div onClick={() => handleBillExampleClick("bill_1")} style={{ cursor: 'pointer', overflow: 'hidden', position: 'relative', borderRadius: 2, border: `2px solid ${APP_COLOR}` }}>
                    {isBillNumber === "bill_1" && <div style={{ position: 'absolute', zIndex: 90, top: "-1em", left: "-2.5em", width: 130, height: 55, background: APP_COLOR, transform: 'rotate(-45deg)' }}>
                      <FaCheckCircle style={{ fontSize: 28, position: "inherit", top: 15, left: 40, zIndex: 999, color: "#fff", transform: 'rotate(45deg)' }} />
                    </div>}
                    <img src={images.bill_1} style={{ width: '100%', maxWidth: 360, minWidth: 360, minHeight: 520, maxHeight: 520 }} alt="Bill example 1" />
                  </div>
                  <div onClick={() => handleBillExampleClick("bill_2")} style={{ cursor: 'pointer', overflow: 'hidden', position: 'relative', borderRadius: 2, border: `2px solid ${APP_COLOR}` }}>
                    {isBillNumber === "bill_2" && <div style={{ position: 'absolute', zIndex: 90, top: "-1em", left: "-2.5em", width: 130, height: 55, background: APP_COLOR, transform: 'rotate(-45deg)' }}>
                      <FaCheckCircle style={{ fontSize: 28, position: "inherit", top: 15, left: 40, zIndex: 999, color: "#fff", transform: 'rotate(45deg)' }} />
                    </div>}
                    <img src={images.bill_2} style={{ width: '100%', maxWidth: 360, minWidth: 360, minHeight: 520, maxHeight: 520 }} alt="Bill example 2" />
                  </div>
                  <div onClick={() => handleBillExampleClick("bill_3")} style={{ cursor: 'pointer', overflow: 'hidden', position: 'relative', borderRadius: 2, border: `2px solid ${APP_COLOR}` }}>
                    {isBillNumber === "bill_3" && <div style={{ position: 'absolute', zIndex: 90, top: "-1em", left: "-2.5em", width: 130, height: 55, background: APP_COLOR, transform: 'rotate(-45deg)' }}>
                      <FaCheckCircle style={{ fontSize: 28, position: "inherit", top: 15, left: 40, zIndex: 999, color: "#fff", transform: 'rotate(45deg)' }} />
                    </div>}
                    <img src={images.bill_3} style={{ width: '100%', maxWidth: 360, minWidth: 360, minHeight: 520, maxHeight: 520 }} alt="Bill example 3" />
                  </div>

                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header>ໃບເກັບເງິນ ແລະ ໃບສະເໜີລາຄາ</Accordion.Header>
              <Accordion.Body>

                <div className="d-flex justify-content-center align-items-start gap-4 flex-wrap">
                  {billOfferPriceExamples.map((item, index) => (
                    <div key={index} style={{ width: "100%", maxWidth: 640, overflow: 'hidden', border: `1px solid ${isBillOfferPrice === item?.type ? APP_COLOR : '#f2f2f2'}` }}>
                      <img src={item.image} alt={item?.type} style={{ width: '100%', height: 450 }} />
                      <Button onClick={() => handleBillOfferPriceExampleClick(item)} variant={isBillOfferPrice === item?.type ? "success" : "outline-success"} className="m-2" >ເລືອກ</Button>
                    </div>
                  ))}

                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Card.Body>
      </Card>


      <LoadingUpdates title="ກຳລັງອັບເດດ..." openLoading={loadingEdit} />
    </>
  );
};

export default SetProduct;


const billOfferPriceExamples = [
  {
    image: images.invoice_detail1,
    title: "ໃບບິນເກັບເງິນ",
    type: "BILL_OFFPRICE_V1"
  },
  {
    image: images.invoice_detail2,
    title: "ໃບບິນເກັບເງິນ",
    type: "BILL_OFFPRICE_V2"
  },
  {
    image: images.invoice_detail3,
    title: "ໃບບິນເກັບເງິນ",
    type: "BILL_OFFPRICE_V3"
  },
  {
    image: images.invoice_detail4,
    title: "ໃບບິນເກັບເງິນ",
    type: "INVOICE_DETAIL_4"
  },
  // {
  //   image: images.invoice_detail1,
  //   title: "ໃບບິນເກັບເງິນ",
  //   type: "BILL_OFFPRICE_V4"
  // },
  // {
  //   image: images.invoice_detail1,
  //   title: "ໃບບິນເກັບເງິນ",
  //   type: "BILL_OFFPRICE_V5"
  // },
]
